import { useEffect } from 'react';
import { useGroup } from '../contexts/GroupContext';
import { isNonEmptySubawardeeId } from '../utils/adminSubawardeeUtils';

/**
 * Keeps `selectedGroup` / localStorage (and thus default `X-Selected-Group` on httpClient)
 * aligned with the admin "Filter by Subawardee" value so non-scoped API calls match the filter.
 */
export function useSyncSelectedGroupFromSubawardee(subawardee: string | null): void {
  const { setSelectedGroup, isGroupAccessible } = useGroup();

  useEffect(() => {
    if (!isNonEmptySubawardeeId(subawardee)) return;
    if (!isGroupAccessible(subawardee)) return;
    setSelectedGroup(subawardee);
  }, [subawardee, setSelectedGroup, isGroupAccessible]);
}
